import { ApplicationInterface } from "../interfaces/ApplicationInterface/Application";
import { CreateApplicationInterface } from "../interfaces/ApplicationInterface/CreateApplicationInterface";
import BaseService from "./BaseService";

export class ApplicationService extends BaseService<ApplicationInterface, CreateApplicationInterface>{ 
    constructor(){
        let url: string = '/application/admin'
        super(url)
    }
}